export default __webpack_public_path__ + "share-post-symbol.png";